(function (w, d, $) {
	var $w = $(w);
	var $d = $(d);
	var $b;
	
	$(function () {
		$b = $('body');
	});

	$.fn.toggleAttr = function(attr) {
		return $(this).attr(attr, function (i, innerAttr) {
			return innerAttr === 'true' ? 'false' : 'true';
		});
	};

	(function() {
		var isIos = /iP(ad|od|hone)/i.test(window.navigator.userAgent);
		var isSafari = !!navigator.userAgent.match(/Version\/[\d\.]+.*Safari/);

		var $html = $('html');
		$html.toggleClass('is-ios', isIos);
		$html.toggleClass('is-safari', isSafari);
		$html.toggleClass('is-apple', isSafari || isIos);
	})();
	
	// Burger and menu
	$(function () {
		var $header = $('header');
		$d.on('click', '.burger', function() {
			$b.toggleClass('header-open');
			$header.toggleClass('header-open');
			$(this).toggleAttr('aria-expanded');
		});
	});

	// Flex Hero Video
	$(function () {
		// Scroll on arrow click
		$d.on('click', 'section.flex-herovideo .arrow', function() {
			var $thisSection = $(this).closest('section.flex-herovideo');
			var $nextSection = $thisSection.siblings('section').first();

			$('html, body').stop().animate({
				scrollTop: $nextSection.offset().top
			}, 1000);
		});
	});

	// Flex Content Layout 2
	$(function () {
		// Play video on click
		var isPlaying = false;
		var $videoContainer = $('section.flex-contentlayout2 .video-container');
		var video = $videoContainer.find('video')[0];
		var toggleVideo = function() {
			if(isPlaying) {
				video.pause();
			} else {
				video.play();
			}
			isPlaying = !isPlaying;
			$videoContainer.toggleClass('video-playing');
		};

		$d.on('click', 'section.flex-contentlayout2 .video-play, section.flex-contentlayout2 video', function(e) {
			e.preventDefault();
			toggleVideo();
		});

		$('.figure').each(function() {
			var $figure = $(this);
			$figure.width($figure.outerWidth());
			var final = parseInt($figure.text());
			$figure.data('ghd-figure-final', final);
			$figure.text('0');

			$figure.on('ghd-figure', function() {
				var $figure = $(this);
				var final = $figure.data('ghd-figure-final');

				if(!final) {
					return;
				}
				$figure.data('ghd-figure-final', false);
				
				var count = 0;
				var to = setInterval(function() {
					$figure.text(count);	

					if(count >= final) {
						clearInterval(to);
					}

					count++;
				}, (900 / final));
			});
		});
	});

	// Flex Stats
	$(function () {
		$('.stat-stat').each(function() {
			var $stat = $(this);
			var text = $stat.text().trim();
			var newText = '';
			if($stat.hasClass('stat-stat-fraction')) {
				var textParts = text.split('/');
				newText = '<span>' + textParts[0].trim() + '</span> / ' + textParts[1].trim();
			} else {
				// percentages
				var number = parseInt(text);
				var remaining = text.replace(number, '');
				newText = '<span>' + number + '</span>' + remaining;
			}
			$stat.html(newText);
			var $number = $stat.find('span');

			$number.width($number.outerWidth());
			var final = parseInt($number.text());
			$number.data('ghd-stat-final', final);
			$number.text('0');

			$stat.on('ghd-stat', function() {
				var $number = $stat.find('span');
				var final = $number.data('ghd-stat-final');

				if(!final) {
					return;
				}

				$number.data('ghd-stat-final', false);

				var count = 0;
				var to = setInterval(function() {
					$number.text(count);	

					if(count >= final) {
						clearInterval(to);
					}

					count++;
				}, (900 / final));
			});
		});
	});

	// Animation classes and trigger events
	$(function() {
		if(!window.IntersectionObserver) {
			return;
		}

		var observer = new IntersectionObserver(function handleIntersection(entries) {
			entries.map(function(entry) {
				if (entry.isIntersecting) {
					if(entry.target.classList.contains('animated')) {
						entry.target.classList.add('animated');
					}

					if(entry.target.classList.contains('figure')) {
						$(entry.target).trigger('ghd-figure');
					}

					if(entry.target.classList.contains('stat-stat')) {
						$(entry.target).trigger('ghd-stat');
					}

					if(entry.target.classList.contains('pie-container') && !entry.target.dataset.ghdPieTriggered) {
						entry.target.dataset.ghdPieTriggered = true;
						$(entry.target).trigger('ghd-pie');
					}
				}
			});
		}, {rootMargin: '0px 0px 0px 0px'});
		document.querySelectorAll('.animate, .figure, .stat-stat, .pie-container').forEach(function(target) {
			observer.observe(target);
		});
	});

	// Scrolling
	$(function() {
		var lastScroll = 0;
		var $header = $('header');
		$w.on('scroll', function() {
			var currentScroll = $w.scrollTop();
			$header.toggleClass('header-scrolled', (currentScroll > 100));
			$header.toggleClass('header-scrolling-up', (currentScroll < lastScroll));
			lastScroll = currentScroll;
		});
	});

	// animate hero arrow opacity
	$(function() {
		var $el = $('section.flex-herovideo .arrow');
		if(!$el.length) {
			return;
		}

		var wHeight = $w.height();
		var percent = 100;
		var update = function() {
			$el.css('opacity', percent + '%');
		};
		var clamp = function(num, min, max) {
			return Math.min(Math.max(num, min), max);
		};

		var elementOffset = $el.offset().top;
		var initialDistanceBetween = false;

		$w.on('scroll', function() {
			var scrollTop = $w.scrollTop();
			var elementScrollInSreen = wHeight - distance;
			var distance = (elementOffset - scrollTop);

			var distanceBetween = elementOffset - scrollTop - 100;
			if(!initialDistanceBetween) {
				initialDistanceBetween = distanceBetween;
			}

			var fraction = distanceBetween / initialDistanceBetween;

			if(elementScrollInSreen >= 0 && elementScrollInSreen < (wHeight * 0.8)) {
				percent = clamp(Math.round(fraction * 100, 2), 0, 100);
				w.requestAnimationFrame(update);
			}
		});
	});

	// Button click tracking
	$(function() {
		// Download report
		$d.on('click', 'a[download="report.pdf"]', function() {
			if(window.lintrk) {
				window.lintrk('track', { conversion_id: 12393420 });
			}
		});

		// Get in touch
		$d.on('click', 'a[href*="get-in-touch"]', function(e) {
			if(window.lintrk) {
				window.lintrk('track', { conversion_id: 12393428 });
			}
		});
	});

	// Findings
	$(function () {
		// mobile table selector opening
		$d.on('click', 'section.flex-findings .findings-tab-active', function() {
			var $findingsTabs = $(this).closest('.findings-tabs');
			$findingsTabs.toggleClass('findings-tabs-open');
		});

		// mobile tab selector selected
		$d.on('click', 'section.flex-findings .findings-tabs-dropdown .findings-tab', function() {
			var tabIndex = $(this).attr('data-tab');
			var $container = $(this).closest('.findings-container');
			
			$container.find('.findings-tabs > .findings-tab')
				.removeClass('findings-tab-active')
				.filter('[data-tab="'+tabIndex+'"]').addClass('findings-tab-active');
			
			$container.find('.findings-tabs-open').removeClass('findings-tabs-open');

			$container.find('.findings-pages .finding')
				.removeClass('finding-active')
				.filter('[data-tab="'+tabIndex+'"]').addClass('finding-active');
		});

		// desktop tab selector selected
		$d.on('click', 'section.flex-findings .findings-tabs > .findings-tab', function() {
			var tabIndex = $(this).attr('data-tab');
			var $container = $(this).closest('.findings-container');
			
			$container.find('.findings-tabs > .findings-tab')
				.removeClass('findings-tab-active')
				.filter('[data-tab="'+tabIndex+'"]').addClass('findings-tab-active');
			
			$container.find('.findings-pages .finding')
				.removeClass('finding-active')
				.filter('[data-tab="'+tabIndex+'"]').addClass('finding-active');
		});

		// pie come into view
		var final = 565;
		$d.on('ghd-pie', 'section.flex-findings .pie-container', function() {
			var $container = $(this);
			var percent = parseInt($container.find('.pie-stat').text()) / 100;
			$container[0].style.setProperty('--ghd-pie-amount', (final * (1 - percent)));

			setTimeout(function() {
				$container.addClass('pie-container-animated');
			}, 300);
		});

		// own carousel the stats
		if($w.width() < 768) {
			$d.find('section.flex-findings .stats').each(function() {
				var $stat = $(this);
				$stat
					.addClass('owl-carousel')
					.owlCarousel({
						items: 1,
					});
			});
		}
	});


	// autoheight 
	$(function () {
		var resizeEventName = 'GHDShocked.autoHeight';

		if ($w.width() < 768) {
			return;
		}

		$d.on(resizeEventName, function () {
			[
				'section.flex-findings .stats.has-percent .stat-title',
				'section.flex-stats .stat > p',
				'section.flex-findings .finding-header',
			].forEach(function(selector) {

				var $el = $(selector);
				var headingHeight = 0;
	
				$el.each(function (j, el) {
					headingHeight = Math.max($(el).outerHeight(), headingHeight);
				});
	
				$el.css('min-height', headingHeight + 'px');
			});
		});

		// run on load and when browser resizes
		$d.trigger(resizeEventName);
		setTimeout(function () {
			$d.trigger(resizeEventName);
		}, 100);
		$w.on('resize', function () {
			$d.trigger(resizeEventName);
		});
	});

	// Cookie banner reset
	$(function () {
		// ctrl + space to clear cookie
		$d.on('keydown', function(event) {
			if(event.ctrlKey && event.which === 32) {
				console.log('GHD: Cookie confirmation removed.');
				var cookieconsent = w.initCookieConsent();
				cookieconsent.eraseCookies(['cc_cookie']);
			}
		});
	});

	// Cookie banner reset
	// https://github.com/orestbida/cookieconsent
	$(function() {
		var cookieconsent = w.initCookieConsent();
		cookieconsent.run({
			page_scripts: true,
			gui_options: {
				consent_modal: {
					layout: 'bar',
					position: 'bottom center',
					transition: 'slide',
					swap_buttons: true,
				},
			},
			current_lang: 'en',
			languages: {
				'en': {
					consent_modal: {
						title: 'Cookie consent',
						description: w.ghd_shocked.cookie.cookieNoice,
						primary_btn: {
							text: w.ghd_shocked.cookie.accept,
							role: 'accept_all'
						},
						secondary_btn: {
							text: w.ghd_shocked.cookie.decline,
							role: 'accept_necessary'
						}
					},
					settings_modal: {
						title: 'Cookie preferences',
						save_settings_btn: 'Save settings',
						accept_all_btn: 'Accept all',
						blocks: [
							{
								title: 'Cookies',
								toggle: {
									value: 'gdpr',
									enabled: true,
								}
							}
						]
					}
				},
			}
		});
	});
})(window, document, window.jQuery); 